import { isNullOrUndefined } from '@swissfex/sfx-commons';

import { SafeAny } from '../../constants';

export class ObjectUtils {
    public static getKeyForValue<Type>(object: unknown, value: unknown): Type {
        if (isNullOrUndefined(object) || isNullOrUndefined(value)) {
            return null;
        }

        const keys = Object.keys(object);
        for (const key of keys) {
            if (object[key] === value) {
                return key as unknown as Type;
            }
        }
        return null;
    }

    public static getValueForObjectPath<T>(obj: SafeAny, path: string): T {
        if (!path?.length) {
            return null;
        }

        let current: SafeAny = obj;
        path.split('.').forEach((section) => {
            if (current == null || !section?.length) {
                return;
            }

            if (!isNaN(+section) && Array.isArray(current)) {
                current = current[parseInt(section, 10)];
            } else {
                current = current[section];
            }
        });

        return current as T;
    }

    public static isObjectOrArray(value: unknown): boolean {
        return value === Object(value);
    }

    public static traverseObjectLeaves(
        value: unknown,
        path: string,
        onLeaf: (path: string, value: unknown) => void
    ): void {
        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                ObjectUtils.traverseObjectLeaves(item, `${path}/${index}`, onLeaf);
            });
            return;
        }

        if (value && typeof value === 'object') {
            Object.keys(value).forEach((key) => {
                ObjectUtils.traverseObjectLeaves((value as Record<string, unknown>)[key], `${path}/${key}`, onLeaf);
            });
            return;
        }

        onLeaf(path, value);
    }

    public static someObjectLeaf(
        value: unknown,
        predicate: (value: unknown, path: string) => boolean,
        path = ''
    ): boolean {
        if (Array.isArray(value)) {
            return value.some((item, index) => ObjectUtils.someObjectLeaf(item, predicate, `${path}/${index}`));
        }

        if (value && typeof value === 'object') {
            return Object.keys(value).some((key) =>
                ObjectUtils.someObjectLeaf((value as Record<string, unknown>)[key], predicate, `${path}/${key}`)
            );
        }

        return predicate(value, path);
    }
}
